export default class TopicItemDto {
    public id: string;
    public title: string;
    public publicationDate: Date;
    public type: string;
  
    constructor() {
      this.id = "";
      this.title = "";
      this.type = "newsPage";
    }
}


// WEBPACK FOOTER //
// ./src/api/topicItemDto.ts